// extracted by mini-css-extract-plugin
export var details = "_em-0";
export var inspectorPopover = "_em-1";